import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "circleBlueButton pointer selected fl mr10",
  style: `top: 20px; left: -15px; font-size: 17px`
}
const _hoisted_2 = {
  key: 0,
  class: "posAb circleBlueButton whiteColor fw600",
  style: {"top":"-10px","right":"-10px","background":"#69d54f"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 3,
  class: "fl ml10 fs13 mt6"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.mag)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "rad10 lskyblueBg pad20 posRe pointer hoverLgreyBg",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMag(_ctx.mag)))
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.mag.name), 1),
        (_ctx.selectedMag && _ctx.selectedMag.id == _ctx.mag.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                width: "17",
                height: "17",
                style: {"margin-top":"-2px"}
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        (_ctx.mag.profile_image_urls && _ctx.mag.profile_image_urls[0])
          ? (_openBlock(), _createBlock(_component_UserIcon, {
              key: 1,
              imageUrl: (_ctx.mag.profile_image_urls || [])[0],
              canEdit: false,
              updateSelf: false,
              width: 30,
              class: "fl",
              style: {"margin-left":"-1px"}
            }, null, 8, ["imageUrl"]))
          : (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
              width: "30",
              height: "30",
              style: {"margin-left":"-1px"},
              class: "fl"
            }, null, 8, _hoisted_4)),
        (_ctx.mag.team_name)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.truncate(_ctx.mag.team_name, 10)), 1)
            ])), [
              [_directive_tooltip, _ctx.mag.team_name.length > 10 ? _ctx.mag.team_name : null]
            ])
          : _createCommentVNode("", true),
        _hoisted_6
      ]))
    : _createCommentVNode("", true)
}